import { defineStore } from "pinia";
import jwtDecode from "jwt-decode";

interface Token {
  context: User;
  exp: number;
  iat: number;
  sub: string;
}

interface User {
  email: string;
  role: string;
}

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: localStorage.getItem("token") || null,
    isAuthenticated: localStorage.getItem("isAuthenticated") === "true" || false,
    user: JSON.parse(localStorage.getItem("user") as string) as User | null,
  }),
  getters: {
    isAdmin: (state) => {
      return state.user?.role === "administrator";
    },
    isTokenExpire: (state) => {
      if (state.token) {
        const payload = jwtDecode(state.token) as Token;

        if (payload.exp !== undefined) {
          const currentDate = new Date();
          const expireDate = new Date(parseInt(String(payload.exp), 10) * 1000);

          if (currentDate >= expireDate) {
            return true;
          }
        }
      }

      return false;
    },
  },
  actions: {
    setJWTToken(jwtToken: string) {
      const token = jwtDecode(jwtToken) as Token;
      const user = token["context"];

      localStorage.setItem("token", jwtToken);
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("user", JSON.stringify(token["context"]));

      this.token = jwtToken;
      this.isAuthenticated = true;
      this.user = user;
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("user");

      this.token = null;
      this.isAuthenticated = false;
      this.user = null;
    },
  },
});
